import Vue from 'vue'

const getPesquisas = async () => {
  try {
    const response = await Vue.prototype.$http.get(`/pesquisas`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getMinhasPesquisas = async () => {
  try {
    const response = await Vue.prototype.$http.get(`/pesquisas/minhas`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getPesquisa = async ({ idPesquisa }) => {
  try {
    const response = await Vue.prototype.$http.get(`/pesquisa/${idPesquisa}`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getRespondedores = async ({ idPesquisa }) => {
  try {
    const response = await Vue.prototype.$http.get(`/pesquisa/${idPesquisa}/respondedores`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const criarPesquisa = async (pesquisa) => {
  try {
    const response = await Vue.prototype.$http.post(`/pesquisa`, pesquisa)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const atualizarPesquisa = async (pesquisa) => {
  try {
    const response = await Vue.prototype.$http.put(`/pesquisa`, pesquisa)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const salvarRespostas = async ({ respostas }) => {
  try {
    const response = await Vue.prototype.$http.post(`/pesquisa/respostas`, respostas)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getRespostasDoUsuario = async ({ idPesquisa, cpfUsuario }) => {
  try {
    const response = await Vue.prototype.$http.get(`/pesquisa/${idPesquisa}/usuario/${cpfUsuario}/respostas`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getEstatisticasPergunta = async ({ idPergunta }) => {
  try {
    const response = await Vue.prototype.$http.get(`/pesquisa/pergunta/${idPergunta}/estatisticas`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

export {
  getPesquisas,
  criarPesquisa,
  atualizarPesquisa,
  getMinhasPesquisas,
  getPesquisa,
  getRespondedores,
  salvarRespostas,
  getRespostasDoUsuario,
  getEstatisticasPergunta
}